import { render, staticRenderFns } from "./scoreConfig.vue?vue&type=template&id=2f48b761&scoped=true"
import script from "./scoreConfig.vue?vue&type=script&lang=js"
export * from "./scoreConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f48b761",
  null
  
)

component.options.__file = "scoreConfig.vue"
export default component.exports